module.exports = __webpack_public_path__ + "static/k2-348466e272159db30e85fcd567c70924.png";